import { Warehouse1CResponse } from "./warehouse-1c-response";

export class DeviceFrom1C {
    sn: string;
    cell: string;
    warehouse: Warehouse1CResponse;
    warehouseArea: Warehouse1CResponse;
}